import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_CompteursStepBar = _resolveComponent("CompteursStepBar")!
  const _component_BottomNavigation = _resolveComponent("BottomNavigation")!
  const _component_InformationCompteurModal = _resolveComponent("InformationCompteurModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('outils.compteur.title')), 1),
        _createVNode(_component_ReglePastille, { cle: "outils.definition" }),
        _createVNode(_component_ReglePastille, { cle: "outils.reinitialisationApresEnvoi" })
      ]),
      _createVNode(_component_CompteursStepBar, { step: _ctx.step }, null, 8, ["step"]),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponent)))
    ]),
    _createVNode(_component_BottomNavigation, {
      cancel: _ctx.cancel,
      first: _ctx.step === 0,
      last: _ctx.step === 2,
      next: _ctx.next,
      back: _ctx.back,
      confirmButtonDisabled: !_ctx.isValid,
      confirm: _ctx.sendMail
    }, null, 8, ["cancel", "first", "last", "next", "back", "confirmButtonDisabled", "confirm"]),
    (_ctx.modalOpen)
      ? (_openBlock(), _createBlock(_component_InformationCompteurModal, {
          key: 0,
          onCancel: _ctx.goHomePage
        }, null, 8, ["onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}